<template>
  <div class="proformas-listado" :class="themeClass">

    <div class="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
      <div>
        <h4 class="fw-bold mb-0" style="color:var(--text-primary)">Proformas / Cotizaciones</h4>
        <small style="color:var(--text-secondary)">Gestiona presupuestos, cobra anticipos y convierte a factura.</small>
      </div>
      <button v-if="puedeCrear" class="btn btn-primary btn-sm" @click="$router.push('/proformas/nueva')">
        <i class="bi bi-plus-lg me-1"></i> Nueva proforma
      </button>
    </div>

    <div class="card mb-3" style="background:var(--secondary-bg-main);border-color:var(--border-main)">
      <div class="card-body py-2">
        <div class="row gy-2">
          <div class="col-md-3">
            <label class="form-label small mb-1">Numero proforma</label>
            <input v-model="filtros.numero_proforma" type="text" class="form-control form-control-sm"
              placeholder="PRO-2026-..." @keyup.enter="cargar" />
          </div>
          <div class="col-md-3">
            <label class="form-label small mb-1">Cliente</label>
            <input v-model="filtros.cliente" type="text" class="form-control form-control-sm"
              placeholder="Nombre o RUC" @keyup.enter="cargar" />
          </div>
          <div class="col-md-2">
            <label class="form-label small mb-1">Estado</label>
            <select v-model="filtros.estado" class="form-select form-select-sm">
              <option value="">Todos</option>
              <option value="borrador">Borrador</option>
              <option value="enviada">Enviada</option>
              <option value="aceptada">Aceptada</option>
              <option value="convertida">Convertida</option>
              <option value="anulada">Anulada</option>
            </select>
          </div>
          <div class="col-md-2">
            <label class="form-label small mb-1">Desde</label>
            <input v-model="filtros.fecha_desde" type="date" class="form-control form-control-sm" />
          </div>
          <div class="col-md-2 d-flex align-items-end gap-1">
            <div class="flex-grow-1">
              <label class="form-label small mb-1">Hasta</label>
              <input v-model="filtros.fecha_hasta" type="date" class="form-control form-control-sm" />
            </div>
            <button class="btn btn-primary btn-sm" @click="cargar">
              <i class="bi bi-search"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-bordered table-sm align-middle small" style="color:var(--text-primary)">
        <thead class="table-light text-center">
          <tr>
            <th>N. Proforma</th>
            <th>Fecha</th>
            <th>Cliente</th>
            <th class="text-end">Total</th>
            <th class="text-end">Anticipos</th>
            <th class="text-end">Saldo</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="cargando">
            <td colspan="8" class="text-center py-4">
              <span class="spinner-border spinner-border-sm me-2"></span>Cargando...
            </td>
          </tr>
          <tr v-else-if="proformas.length === 0">
            <td colspan="8" class="text-center py-3" style="color:var(--text-muted)">
              No hay proformas para mostrar.
            </td>
          </tr>
          <tr v-else v-for="pf in proformas" :key="pf.id">
            <td class="fw-semibold">{{ pf.numero_proforma }}</td>
            <td class="text-center">{{ formatearFecha(pf.fecha_emision) }}</td>
            <td>{{ pf.nombre_cliente }}</td>
            <td class="text-end">{{ dinero(pf.total) }}</td>
            <td class="text-end text-success fw-semibold">{{ dinero(pf.total_anticipos) }}</td>
            <td class="text-end fw-bold">{{ dinero(parseFloat(pf.total) - parseFloat(pf.total_anticipos)) }}</td>
            <td class="text-center">
              <span :class="['badge', badgeEstado(pf.estado)]">{{ labelEstado(pf.estado) }}</span>
            </td>
            <td class="text-center">
              <div class="d-flex gap-1 justify-content-center flex-wrap">
                <button class="btn btn-outline-secondary btn-sm" title="Ver detalle" @click="verDetalle(pf)">
                  <i class="bi bi-eye"></i>
                </button>
                <button class="btn btn-outline-dark btn-sm" title="Imprimir PDF A4" @click="imprimirProforma(pf)">
                  <i class="bi bi-printer"></i>
                </button>
                <button v-if="puedeEditar && !['convertida','anulada'].includes(pf.estado)"
                  class="btn btn-outline-primary btn-sm" title="Editar"
                  @click="$router.push('/proformas/editar/' + pf.id)">
                  <i class="bi bi-pencil"></i>
                </button>
                <button v-if="puedeCrear && !['convertida','anulada'].includes(pf.estado)"
                  class="btn btn-outline-success btn-sm" title="Cobrar anticipo"
                  @click="abrirModalAnticipo(pf)">
                  <i class="bi bi-cash-coin"></i>
                </button>
                <button v-if="puedeEditar && !['convertida','anulada'].includes(pf.estado)"
                  class="btn btn-outline-warning btn-sm" title="Convertir a factura"
                  @click="convertirAFactura(pf)">
                  <i class="bi bi-arrow-right-circle"></i>
                </button>
                <button v-if="puedeEliminar && !['convertida','anulada'].includes(pf.estado)"
                  class="btn btn-outline-danger btn-sm" title="Anular"
                  @click="anular(pf)">
                  <i class="bi bi-x-circle"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="totalRegistros > limite" class="d-flex justify-content-between align-items-center mt-2 small">
      <span style="color:var(--text-secondary)">
        Mostrando {{ desplazamiento + 1 }}-{{ Math.min(desplazamiento + proformas.length, totalRegistros) }}
        de {{ totalRegistros }}
      </span>
      <div class="d-flex gap-1">
        <button class="btn btn-outline-secondary btn-sm" :disabled="desplazamiento === 0"
          @click="cambiarPagina(-1)">Anterior</button>
        <button class="btn btn-outline-secondary btn-sm"
          :disabled="desplazamiento + limite >= totalRegistros"
          @click="cambiarPagina(1)">Siguiente</button>
      </div>
    </div>

    <!-- Modal detalle -->
    <div v-if="modalDetalle.visible" class="modal d-block" tabindex="-1" style="background:rgba(0,0,0,.5);z-index:1050">
      <div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content" style="background:var(--secondary-bg-main);color:var(--text-primary)">
          <div class="modal-header bg-primary text-white py-2">
            <h6 class="modal-title mb-0">
              <i class="bi bi-file-text me-2"></i>Proforma {{ modalDetalle.proforma && modalDetalle.proforma.numero_proforma }}
            </h6>
            <button type="button" class="btn-close btn-close-white" @click="modalDetalle.visible = false"></button>
          </div>
          <div class="modal-body py-2 small" v-if="modalDetalle.proforma">
            <div class="row gy-1 mb-3">
              <div class="col-md-4"><strong>Cliente:</strong> {{ modalDetalle.proforma.nombre_cliente }}</div>
              <div class="col-md-4"><strong>Fecha:</strong> {{ formatearFecha(modalDetalle.proforma.fecha_emision) }}</div>
              <div class="col-md-4"><strong>Estado:</strong>
                <span :class="['badge ms-1', badgeEstado(modalDetalle.proforma.estado)]">
                  {{ labelEstado(modalDetalle.proforma.estado) }}
                </span>
              </div>
              <div class="col-12" v-if="modalDetalle.proforma.notas">
                <strong>Notas:</strong> {{ modalDetalle.proforma.notas }}
              </div>
            </div>
            <h6 class="small fw-bold mb-1">Productos / Servicios</h6>
            <div class="table-responsive mb-3">
              <table class="table table-sm table-bordered small mb-0">
                <thead class="table-light text-center">
                  <tr>
                    <th>Codigo</th><th>Nombre</th>
                    <th>Cant.</th><th>P.Unit.</th><th>%Desc.</th>
                    <th>%IVA</th><th>Subtotal</th><th>IVA</th><th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="d in modalDetalle.detalles" :key="d.id">
                    <td>{{ d.codigo }}</td>
                    <td>{{ d.nombre }}</td>
                    <td class="text-end">{{ d.cantidad }}</td>
                    <td class="text-end">{{ dinero(d.precio_unitario) }}</td>
                    <td class="text-end">{{ d.descuento }}%</td>
                    <td class="text-end">{{ d.porcentaje_iva }}%</td>
                    <td class="text-end">{{ dinero(d.subtotal) }}</td>
                    <td class="text-end">{{ dinero(d.iva) }}</td>
                    <td class="text-end fw-semibold">{{ dinero(d.total) }}</td>
                  </tr>
                </tbody>
                <tfoot class="table-light">
                  <tr>
                    <td colspan="6" class="text-end fw-semibold">Subtotal</td>
                    <td class="text-end fw-semibold" colspan="3">{{ dinero(modalDetalle.proforma.subtotal) }}</td>
                  </tr>
                  <tr>
                    <td colspan="6" class="text-end fw-semibold">IVA</td>
                    <td class="text-end fw-semibold" colspan="3">{{ dinero(modalDetalle.proforma.total_iva) }}</td>
                  </tr>
                  <tr>
                    <td colspan="6" class="text-end fw-bold text-primary">TOTAL</td>
                    <td class="text-end fw-bold text-primary" colspan="3">{{ dinero(modalDetalle.proforma.total) }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <h6 class="small fw-bold mb-1">Anticipos cobrados</h6>
            <div v-if="modalDetalle.anticipos.length === 0" class="text-muted small mb-2">Sin anticipos registrados.</div>
            <div class="table-responsive" v-else>
              <table class="table table-sm table-bordered small mb-0">
                <thead class="table-light text-center">
                  <tr><th>Metodo</th><th>Destino</th><th>Referencia</th><th class="text-end">Monto</th><th>Observacion</th></tr>
                </thead>
                <tbody>
                  <tr v-for="ant in modalDetalle.anticipos" :key="ant.id">
                    <td class="text-center">{{ ant.metodo_pago }}</td>
                    <td class="text-center">{{ ant.nombre_caja || ant.nombre_banco || ant.destino_tipo }}</td>
                    <td>{{ ant.numero_referencia || '-' }}</td>
                    <td class="text-end fw-semibold text-success">{{ dinero(ant.monto) }}</td>
                    <td>{{ ant.observacion || '-' }}</td>
                  </tr>
                </tbody>
                <tfoot class="table-light">
                  <tr>
                    <td colspan="3" class="text-end fw-bold">Total anticipos</td>
                    <td class="text-end fw-bold text-success">{{ dinero(modalDetalle.proforma.total_anticipos) }}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td colspan="3" class="text-end fw-bold text-danger">Saldo pendiente</td>
                    <td class="text-end fw-bold text-danger">
                      {{ dinero(parseFloat(modalDetalle.proforma.total) - parseFloat(modalDetalle.proforma.total_anticipos)) }}
                    </td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <div class="modal-footer py-2" v-if="modalDetalle.proforma">
            <button class="btn btn-secondary btn-sm" @click="modalDetalle.visible = false">Cerrar</button>
            <!-- Imprimir PDF A4 -->
            <button class="btn btn-outline-dark btn-sm" @click="imprimirProforma(modalDetalle.proforma)"
              :disabled="modalDetalle.imprimiendo" title="Imprimir PDF A4">
              <span v-if="modalDetalle.imprimiendo" class="spinner-border spinner-border-sm me-1"></span>
              <i v-else class="bi bi-printer me-1"></i>Imprimir PDF
            </button>
            <!-- Cambiar estado -->
            <div v-if="!['convertida','anulada'].includes(modalDetalle.proforma.estado)" class="d-flex align-items-center gap-2">
              <select v-model="modalDetalle.nuevoEstado" class="form-select form-select-sm" style="width:auto">
                <option value="borrador">Borrador</option>
                <option value="enviada">Enviada</option>
                <option value="aceptada">Aceptada</option>
              </select>
              <button class="btn btn-outline-primary btn-sm"
                :disabled="modalDetalle.nuevoEstado === modalDetalle.proforma.estado"
                @click="cambiarEstadoProforma(modalDetalle.proforma)">
                <i class="bi bi-arrow-repeat me-1"></i>Cambiar estado
              </button>
            </div>
            <button v-if="!['convertida','anulada'].includes(modalDetalle.proforma.estado)"
              class="btn btn-success btn-sm"
              @click="abrirModalAnticipo(modalDetalle.proforma); modalDetalle.visible = false">
              <i class="bi bi-cash-coin me-1"></i>Cobrar anticipo
            </button>
            <button v-if="!['convertida','anulada'].includes(modalDetalle.proforma.estado)"
              class="btn btn-warning btn-sm"
              @click="convertirAFactura(modalDetalle.proforma); modalDetalle.visible = false">
              <i class="bi bi-arrow-right-circle me-1"></i>Convertir a factura
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal anticipo -->
    <div v-if="modalAnticipo.visible" class="modal d-block" tabindex="-1" style="background:rgba(0,0,0,.5);z-index:1060">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" style="background:var(--secondary-bg-main);color:var(--text-primary)">
          <div class="modal-header bg-success text-white py-2">
            <h6 class="modal-title mb-0"><i class="bi bi-cash-coin me-2"></i>Cobrar anticipo</h6>
            <button type="button" class="btn-close btn-close-white" @click="modalAnticipo.visible = false"></button>
          </div>
          <div class="modal-body py-2 small">
            <div class="alert alert-info py-1 small mb-2" v-if="modalAnticipo.proforma">
              <strong>{{ modalAnticipo.proforma.numero_proforma }}</strong> -
              Total: <strong>{{ dinero(modalAnticipo.proforma.total) }}</strong> |
              Anticipos: <strong>{{ dinero(modalAnticipo.proforma.total_anticipos) }}</strong> |
              Saldo: <strong>{{ dinero(parseFloat(modalAnticipo.proforma.total || 0) - parseFloat(modalAnticipo.proforma.total_anticipos || 0)) }}</strong>
            </div>
            <div v-if="modalAnticipo.error" class="alert alert-danger py-1 small mb-2">{{ modalAnticipo.error }}</div>
            <div class="mb-2">
              <label class="form-label fw-semibold mb-1">Monto anticipo *</label>
              <div class="btn-group btn-group-sm mb-2 w-100" role="group">
                <input type="radio" class="btn-check" id="tipoValor" v-model="formAnticipo.tipo_calculo" value="valor" />
                <label class="btn btn-outline-primary" for="tipoValor"><i class="bi bi-currency-dollar me-1"></i>Valor fijo</label>
                <input type="radio" class="btn-check" id="tipoPorcentaje" v-model="formAnticipo.tipo_calculo" value="porcentaje" />
                <label class="btn btn-outline-primary" for="tipoPorcentaje"><i class="bi bi-percent me-1"></i>Porcentaje</label>
              </div>
              <input v-if="formAnticipo.tipo_calculo === 'valor'"
                v-model.number="formAnticipo.monto" type="number" step="0.01" min="0.01"
                class="form-control form-control-sm" />
              <div v-else class="d-flex align-items-center gap-2">
                <div class="input-group input-group-sm" style="max-width:150px">
                  <input v-model.number="formAnticipo.porcentaje" type="number" step="1" min="1" max="100"
                    class="form-control form-control-sm" />
                  <span class="input-group-text">%</span>
                </div>
                <span class="text-muted small">= <strong class="text-success">{{ dinero(montoCalculadoAnticipo) }}</strong></span>
              </div>
            </div>
            <div class="mb-2">
              <label class="form-label fw-semibold mb-1">Metodo de pago *</label>
              <select v-model="formAnticipo.metodo_pago" class="form-select form-select-sm" @change="onCambioMetodoPago">
                <option value="efectivo">Efectivo</option>
                <option value="tarjeta">Tarjeta</option>
                <option value="transferencia">Transferencia bancaria</option>
                <option value="cheque">Cheque</option>
              </select>
            </div>
            <div class="mb-2">
              <label class="form-label fw-semibold mb-1">Destino *</label>
              <div class="d-flex gap-2 mb-1">
                <div class="form-check">
                  <input class="form-check-input" type="radio" v-model="formAnticipo.destino_tipo" value="caja" id="dCaja" />
                  <label class="form-check-label" for="dCaja">Caja</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" v-model="formAnticipo.destino_tipo" value="banco" id="dBanco" />
                  <label class="form-check-label" for="dBanco">Banco</label>
                </div>
              </div>
              <select v-if="formAnticipo.destino_tipo === 'caja'" v-model="formAnticipo.destino_id"
                class="form-select form-select-sm">
                <option value="">-- Seleccione caja --</option>
                <option v-for="c in cajas" :key="c.id" :value="c.id">{{ c.nombre_caja }}</option>
              </select>
              <select v-else v-model="formAnticipo.destino_id" class="form-select form-select-sm">
                <option value="">-- Seleccione banco --</option>
                <option v-for="b in bancos" :key="b.id" :value="b.id">{{ b.nombre_banco }} - {{ b.numero_cuenta }}</option>
              </select>
            </div>
            <div class="mb-2" v-if="formAnticipo.metodo_pago !== 'efectivo'">
              <label class="form-label fw-semibold mb-1">N. referencia / comprobante</label>
              <input v-model="formAnticipo.numero_referencia" type="text"
                class="form-control form-control-sm" placeholder="Opcional" />
            </div>
            <div class="mb-1">
              <label class="form-label fw-semibold mb-1">Observacion</label>
              <input v-model="formAnticipo.observacion" type="text"
                class="form-control form-control-sm" placeholder="Opcional" />
            </div>
          </div>
          <div class="modal-footer py-2">
            <button class="btn btn-secondary btn-sm" @click="modalAnticipo.visible = false">Cancelar</button>
            <button class="btn btn-success btn-sm" @click="guardarAnticipo" :disabled="modalAnticipo.guardando">
              <span v-if="modalAnticipo.guardando" class="spinner-border spinner-border-sm me-1"></span>
              {{ modalAnticipo.guardando ? 'Guardando...' : 'Registrar anticipo' }}
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/services/api'
import themeManager from '@/store/theme'
import notificaciones from '@/services/notificationService.js'

export default {
  name: 'ClientVentasProformar',

  data() {
    return {
      cargando: false,
      proformas: [],
      totalRegistros: 0,
      limite: 50,
      desplazamiento: 0,
      filtros: {
        numero_proforma: '',
        cliente: '',
        estado: '',
        fecha_desde: '',
        fecha_hasta: '',
      },
      cajas: [],
      bancos: [],
      modalDetalle: { visible: false, proforma: null, detalles: [], anticipos: [], nuevoEstado: '', imprimiendo: false },
      modalAnticipo: { visible: false, proforma: null, error: '', guardando: false },
      formAnticipo: {
        tipo_calculo: 'valor', monto: 0, porcentaje: 100,
        metodo_pago: 'efectivo', destino_tipo: 'caja',
        destino_id: '', numero_referencia: '', observacion: '',
      },
    }
  },

  computed: {
    themeClass() { return themeManager.themeClass },
    puedeCrear() {
      return this.$store.getters.puedoHacer('/proformas', 'crear')
    },
    puedeEditar() {
      return this.$store.getters.puedoHacer('/proformas', 'editar')
    },
    puedeEliminar() {
      return this.$store.getters.puedoHacer('/proformas', 'eliminar')
    },
    montoCalculadoAnticipo() {
      if (!this.modalAnticipo.proforma) return 0
      var saldo = parseFloat(this.modalAnticipo.proforma.total || 0) - parseFloat(this.modalAnticipo.proforma.total_anticipos || 0)
      var pct   = parseFloat(this.formAnticipo.porcentaje) || 0
      return Math.round(saldo * pct / 100 * 100) / 100
    },
  },

  async mounted() {
    await Promise.allSettled([this.cargar(), this.cargarCajas(), this.cargarBancos()])
  },

  methods: {
    async cargar() {
      this.cargando = true
      try {
        var { data } = await api.get('/proformas', {
          params: {
            numero_proforma: this.filtros.numero_proforma || undefined,
            cliente:         this.filtros.cliente        || undefined,
            estado:          this.filtros.estado         || undefined,
            fecha_desde:     this.filtros.fecha_desde    || undefined,
            fecha_hasta:     this.filtros.fecha_hasta    || undefined,
            limite:          this.limite,
            desplazamiento:  this.desplazamiento,
          },
        })
        this.proformas      = Array.isArray(data && data.data)  ? data.data  : []
        this.totalRegistros = (data && data.total) ? data.total : 0
      } catch (e) {
        this.mostrarNotificacion('Error al cargar proformas', 'error')
      } finally {
        this.cargando = false
      }
    },

    async cargarCajas() {
      try {
        var { data } = await api.get('/cajas')
        this.cajas = Array.isArray(data && data.cajas) ? data.cajas : []
      } catch (e) { /* silencioso */ }
    },

    async cargarBancos() {
      try {
        var { data } = await api.get('/bancos')
        this.bancos = Array.isArray(data && data.bancos) ? data.bancos : []
      } catch (e) { /* silencioso */ }
    },

    cambiarPagina(direccion) {
      this.desplazamiento = Math.max(0, this.desplazamiento + direccion * this.limite)
      this.cargar()
    },

    async verDetalle(pf) {
      try {
        var { data } = await api.get('/proformas/' + pf.id)
        this.modalDetalle.proforma    = data.data
        this.modalDetalle.detalles    = (data.data && data.data.detalles)  || []
        this.modalDetalle.anticipos   = (data.data && data.data.anticipos) || []
        this.modalDetalle.nuevoEstado = (data.data && data.data.estado)    || 'borrador'
        this.modalDetalle.visible     = true
      } catch (e) {
        this.mostrarNotificacion('Error al cargar el detalle', 'error')
      }
    },

    abrirModalAnticipo(pf) {
      this.modalAnticipo.proforma  = pf
      this.modalAnticipo.error     = ''
      this.modalAnticipo.guardando = false
      var saldo = parseFloat(pf.total || 0) - parseFloat(pf.total_anticipos || 0)
      this.formAnticipo = {
        tipo_calculo:      'valor',
        monto:             Math.round(saldo * 100) / 100,
        porcentaje:        100,
        metodo_pago:       'efectivo',
        destino_tipo:      'caja',
        destino_id:        (this.cajas[0] && this.cajas[0].id) || '',
        numero_referencia: '',
        observacion:       '',
      }
      this.modalAnticipo.visible = true
    },

    onCambioMetodoPago() {
      if (this.formAnticipo.metodo_pago === 'transferencia') {
        this.formAnticipo.destino_tipo = 'banco'
        this.formAnticipo.destino_id   = (this.bancos[0] && this.bancos[0].id) || ''
      }
    },

    async guardarAnticipo() {
      var pf         = this.modalAnticipo.proforma
      var form       = this.formAnticipo
      var montoFinal = form.tipo_calculo === 'porcentaje'
        ? this.montoCalculadoAnticipo
        : form.monto
      if (!montoFinal || montoFinal <= 0) {
        this.modalAnticipo.error = 'El monto debe ser mayor a 0.'
        return
      }
      if (!form.destino_id) {
        this.modalAnticipo.error = 'Seleccione una caja o banco de destino.'
        return
      }
      this.modalAnticipo.error     = ''
      this.modalAnticipo.guardando = true
      try {
        await api.post('/proformas/' + pf.id + '/anticipo', {
          monto:             montoFinal,
          metodo_pago:       form.metodo_pago,
          destino_tipo:      form.destino_tipo,
          destino_id:        form.destino_id,
          numero_referencia: form.numero_referencia || undefined,
          observacion:       form.observacion       || undefined,
        })
        this.mostrarNotificacion('Anticipo registrado correctamente.', 'exito')
        this.modalAnticipo.visible = false
        this.cargar()
      } catch (e) {
        this.modalAnticipo.error = (e && e.response && e.response.data && e.response.data.error) || 'Error al registrar el anticipo.'
      } finally {
        this.modalAnticipo.guardando = false
      }
    },

    async imprimirProforma(pf) {
      this.modalDetalle.imprimiendo = true
      // Abrir ventana ANTES del await para evitar bloqueo de popups
      var ventana = window.open('', '_blank')
      if (ventana) {
        ventana.document.write('<html><body style="font-family:sans-serif;padding:2rem;">Generando PDF, por favor espere...</body></html>')
      }
      try {
        var resp = await api.get('/proformas/' + pf.id + '/pdf', { responseType: 'blob' })
        var blob = new Blob([resp.data], { type: 'application/pdf' })
        var url  = URL.createObjectURL(blob)
        if (ventana && !ventana.closed) {
          ventana.location.href = url
        } else {
          // Fallback si la ventana fue cerrada
          var a   = document.createElement('a')
          a.href  = url
          a.target = '_blank'
          a.rel    = 'noopener noreferrer'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }
        setTimeout(function() { URL.revokeObjectURL(url) }, 120000)
      } catch (e) {
        if (ventana && !ventana.closed) ventana.close()
        var msg = 'Error al generar el PDF'
        if (e && e.response) {
          // Si el error viene como blob, leerlo como texto
          if (e.response.data instanceof Blob) {
            var reader = new FileReader()
            reader.onload = function() {
              try {
                var obj = JSON.parse(reader.result)
                notificaciones.error(obj.error || msg)
              } catch (_) {
                notificaciones.error(msg)
              }
            }
            reader.readAsText(e.response.data)
            return
          }
          msg = (e.response.data && e.response.data.error) || msg
        }
        notificaciones.error(msg)
      } finally {
        this.modalDetalle.imprimiendo = false
      }
    },

    async convertirAFactura(pf) {
      try {
        var { data } = await api.post('/proformas/' + pf.id + '/convertir')
        // Guardar datos en sessionStorage; ClientVentas los lee al montar
        sessionStorage.setItem('proforma_prefill', JSON.stringify(data))
        this.$router.push('/ventas/facturacion')
      } catch (e) {
        this.mostrarNotificacion((e && e.response && e.response.data && e.response.data.error) || 'Error al convertir la proforma.', 'error')
      }
    },

    async anular(pf) {
      if (!window.confirm('Confirma anular la proforma ' + pf.numero_proforma + '?')) return
      try {
        await api.post('/proformas/' + pf.id + '/anular')
        this.mostrarNotificacion('Proforma anulada.', 'exito')
        this.cargar()
      } catch (e) {
        this.mostrarNotificacion((e && e.response && e.response.data && e.response.data.error) || 'Error al anular la proforma.', 'error')
      }
    },

    async cambiarEstadoProforma(pf) {
      var nuevo = this.modalDetalle.nuevoEstado
      if (!nuevo || nuevo === pf.estado) return
      try {
        await api.patch('/proformas/' + pf.id + '/estado', { estado: nuevo })
        this.modalDetalle.proforma.estado = nuevo
        this.mostrarNotificacion('Estado actualizado a "' + this.labelEstado(nuevo) + '".', 'exito')
        this.cargar()
      } catch (e) {
        this.mostrarNotificacion((e && e.response && e.response.data && e.response.data.error) || 'Error al cambiar el estado.', 'error')
      }
    },

    dinero(valor) {
      var n = Number(valor)
      if (isNaN(n)) return '-'
      return n.toLocaleString('es-EC', { style: 'currency', currency: 'USD' })
    },

    formatearFecha(s) {
      if (!s) return '-'
      var partes = String(s).split('-')
      if (partes.length === 3) return partes[2] + '/' + partes[1] + '/' + partes[0]
      var d = new Date(s)
      return isNaN(d) ? s : d.toLocaleDateString('es-EC')
    },

    badgeEstado(estado) {
      var mapa = {
        borrador:   'bg-secondary',
        enviada:    'bg-info text-dark',
        aceptada:   'bg-primary',
        convertida: 'bg-success',
        anulada:    'bg-danger',
      }
      return mapa[estado] || 'bg-secondary'
    },

    labelEstado(estado) {
      var mapa = {
        borrador:   'Borrador',
        enviada:    'Enviada',
        aceptada:   'Aceptada',
        convertida: 'Convertida',
        anulada:    'Anulada',
      }
      return mapa[estado] || estado
    },

    mostrarNotificacion(mensaje, tipo) {
      if (tipo === 'exito' || tipo === 'success') notificaciones.success(mensaje)
      else if (tipo === 'error') notificaciones.error(mensaje)
      else if (tipo === 'advertencia' || tipo === 'warning') notificaciones.warning(mensaje)
      else notificaciones.info(mensaje)
    },
  },
}
</script>

<style scoped>
.proformas-listado {
  padding: 1.25rem;
  color: var(--text-primary);
}
</style>